import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import Group from "@material-ui/icons/Group";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import TrendingUp from "@material-ui/icons/TrendingUp";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Send from "@material-ui/icons/Send";
import Receipt from "@material-ui/icons/Receipt";
import AccountBalance from "@material-ui/icons/AccountBalance";
import Refresh from "@material-ui/icons/Refresh";
import { GetData } from "../../api/service";

const COLORS = {
  text: "#1F2937",
  accent: "#7C3AED",
};

const CARD_THEMES = {
  indigo:  { bg: "linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)", shadow: "0 8px 20px rgba(79,70,229,0.22)" },
  violet:  { bg: "linear-gradient(135deg, #7C3AED 0%, #9333EA 100%)", shadow: "0 8px 20px rgba(124,58,237,0.22)" },
  emerald: { bg: "linear-gradient(135deg, #059669 0%, #10B981 100%)", shadow: "0 8px 20px rgba(16,185,129,0.22)" },
  teal:    { bg: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)", shadow: "0 8px 20px rgba(20,184,166,0.22)" },
  amber:   { bg: "linear-gradient(135deg, #D97706 0%, #F59E0B 100%)", shadow: "0 8px 20px rgba(245,158,11,0.22)" },
  purple:  { bg: "linear-gradient(135deg, #6D28D9 0%, #7C3AED 100%)", shadow: "0 8px 20px rgba(109,40,217,0.22)" },
  slate:   { bg: "linear-gradient(135deg, #334155 0%, #475569 100%)", shadow: "0 8px 20px rgba(51,65,85,0.22)" },
  rose:    { bg: "linear-gradient(135deg, #BE123C 0%, #E11D48 100%)", shadow: "0 8px 20px rgba(225,29,72,0.22)" },
};

function formatMoney(v) {
  const n = Number(v);
  if (!isFinite(n)) return "—";
  return "₹ " + n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function formatCount(v) {
  const n = Number(v);
  if (!isFinite(n)) return "—";
  return n.toLocaleString("en-IN");
}

function StatCard({ theme, icon, label, value, size }) {
  const t = CARD_THEMES[theme] || CARD_THEMES.slate;
  const large = size === "large";
  return (
    <div
      style={{
        background: t.bg,
        color: "white",
        borderRadius: 14,
        padding: large ? "24px 26px" : "20px 22px",
        boxShadow: t.shadow,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: large ? 130 : 112,
      }}
    >
      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            opacity: 0.9,
          }}
        >
          {label}
        </div>
        <div
          style={{
            fontSize: large ? 30 : 24,
            fontWeight: 700,
            marginTop: 8,
            lineHeight: 1.1,
            wordBreak: "break-word",
          }}
        >
          {value}
        </div>
      </div>
      <div
        style={{
          background: "rgba(255,255,255,0.18)",
          borderRadius: "50%",
          width: large ? 60 : 52,
          height: large ? 60 : 52,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          marginLeft: 14,
        }}
      >
        {icon}
      </div>
    </div>
  );
}

function SectionHeader({ children }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        margin: "22px 0 14px 0",
        color: COLORS.text,
        fontWeight: 600,
        fontSize: 15,
        letterSpacing: 0.2,
      }}
    >
      <span
        style={{
          width: 4,
          height: 18,
          background: COLORS.accent,
          borderRadius: 2,
          display: "inline-block",
        }}
      />
      {children}
    </div>
  );
}

export default class Stats extends Component {
  state = {
    current_balance: 0.0,
    op_bal: 0.0,
    cr_bal: 0.0,
    user_count: 0,
    debit: 0,
    credit: 0,
    total_earning: 0,
    total_tds: 0,
    total_admin: 0,
    repurchase_wallet: 0,
    total_payout: 0,
    total_payout_given: 0,
  };

  componentDidMount() {
    GetData(`/get-dashboard-admin`).then((resp) => {
      if (resp != false) {
        this.setState({
          ...resp,
        });
      }
    });

    GetData(`/${this.props.apikey}/${this.props.username}/gettotaluser`).then(
      (resp) => {
        this.setState({
          user_count: resp,
        });
      }
    );
  }

  render() {
    return (
      <div style={{ padding: 20 }}>
        {/* Members & turnover — hero row */}
        <SectionHeader>Members & Turnover</SectionHeader>
        <Grid container spacing={16}>
          <Grid item xs={12} md={6}>
            <StatCard
              theme="indigo"
              size="large"
              icon={<Group style={{ fontSize: 30, color: "white" }} />}
              label="Current Active Users"
              value={formatCount(this.state.user_count)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <StatCard
              theme="violet"
              size="large"
              icon={<SwapHoriz style={{ fontSize: 30, color: "white" }} />}
              label="Total Turnover"
              value={formatMoney(
                parseFloat(parseFloat(806) * 3000 + parseFloat(335) * 2300 + (parseFloat(this.state.user_count) - 806 - 335) * 2500).toFixed(2)
              )}
            />
          </Grid>
        </Grid>

        {/* Income Overview */}
        <SectionHeader>Income Overview</SectionHeader>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              theme="emerald"
              icon={<TrendingUp style={{ fontSize: 26, color: "white" }} />}
              label="Total Income Generated"
              value={formatMoney(parseFloat(this.state.total_earning).toFixed(2))}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              theme="teal"
              icon={<MonetizationOn style={{ fontSize: 26, color: "white" }} />}
              label="Net Income Generated"
              value={formatMoney(parseFloat(this.state.total_payout).toFixed(2))}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              theme="amber"
              icon={<Send style={{ fontSize: 26, color: "white" }} />}
              label="Total Payout Given"
              value={formatMoney(parseFloat(this.state.total_payout_given).toFixed(2))}
            />
          </Grid>
        </Grid>

        {/* Deductions & Wallets */}
        <SectionHeader>Deductions & Wallets</SectionHeader>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              theme="purple"
              icon={<Receipt style={{ fontSize: 26, color: "white" }} />}
              label="Total TDS Collected"
              value={formatMoney(parseFloat(this.state.total_tds).toFixed(2))}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              theme="slate"
              icon={<AccountBalance style={{ fontSize: 26, color: "white" }} />}
              label="Total Admin Amount"
              value={formatMoney(parseFloat(this.state.total_admin).toFixed(2))}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              theme="rose"
              icon={<Refresh style={{ fontSize: 26, color: "white" }} />}
              label="Total Repurchase Wallet"
              value={formatMoney(parseFloat(this.state.repurchase_wallet).toFixed(2))}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}
